import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Route } from 'react-router-dom'

class PrivateRouteNow extends React.Component {
    render() {
        const { isAuthorized, component: Component, ...rest } = this.props

        return (
            <Route
                {...rest}
                render={props => {
                    return isAuthorized ? <Component {...props} /> : <Redirect push to="/now/register" />
                }}
            />
        )
    }
}

const mapStateToProps = state => ({
    isAuthorized: state.admin.isAuthorized
})

export default connect(
    mapStateToProps,
    null
)(PrivateRouteNow)
